module.exports = __webpack_public_path__ + "img/yes.e42d6c41.png";